export const defaultCriteriaFilter: AppProps.CriteriaFilter = {
  filterForms: [],
  searchForms: [],
  filters: [],
  dateFilter: undefined
};
